<template>
  <div>
    <Navbar/>
    <h4>Examen</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idExamen" class="form-label">IdExamen</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idExamen" name="idExamen" v-model="datoExamen.idExamen" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idTipoExamen" class="form-label"> Tipo Examen</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idTipoExamen" name="idTipoExamen" v-model="datoExamen.idTipoExamen">
                      <option v-for="tipoExamen in tipoExamens" :value="tipoExamen.idTipoExamen" :key="tipoExamen.idTipoExamen">
                        {{ tipoExamen.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoExamen.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarExamen" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditExamen" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdElemExam</th>
          <th scope="col">IdElemento</th>
          <th scope="col">IdExamen</th>
          <th scope="col">Estado</th>
          <th scope="col">ExamenNombre</th>
          <th scope="col">ElementoNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="elemexam in datosPaginados" :key="elemexam.idElemExam">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(elemexam.idElemExam)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(elemexam.idElemExam)" title="Editar">edit_square</i></td>
          <td>{{elemexam.idElemExam}}</td>
          <td>{{elemexam.idElemento}}</td>
          <td>{{elemexam.idExamen}}</td>
          <td>{{elemexam.estado}}</td>
          <td>{{elemexam.examenNombre}}</td>
          <td>{{elemexam.elementoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteExamen(elemexam.idElemExam)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idElemExam" class="form-label">IdElemExam</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idElemExam" name="idElemExam" v-model="datoElemExam.idElemExam" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idElemento" name="idElemento" v-model="datoElemExam.idElemento">
                      <option v-for="elemento in elementos" :value="elemento.idElemento" :key="elemento.idElemento">
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idExamen" class="form-label">IdExamen</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idExamen" name="idExamen" v-model="datoElemExam.idExamen" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarElemExam" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditElemExam" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      examens : [],
      datoExamen : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idExamen: '',
      tipoExamens : [],
// Variables master
// Variables details
      elemexams : [],
      datoElemExam : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      elementos : [],
//      examens : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idExamen = this.$route.params.p_idexamen
    this.abrirEditar(this.p_idExamen)
    this.getDataPagina(this.paginaActual)
    this.fetchTipoExamens()
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idTipoExamen'
        ,'nombre'
      ];
      const requiredFieldsText = [
        'idTipoExamen'
        ,'nombre'
      ];
      return validarForm(this.datoExamen, requiredFields, requiredFieldsText);
    },
    async guardarExamen(){
      if(this.validarForm() === 1){
        try {
          await api.post('/examens', this.datoExamen)
          swal("Correcto!", "Examen creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditExamen(){
      if(this.validarForm() === 1){
        try {
          await api.post('/examens', this.datoExamen)
          swal("Correcto!", "Examen creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoExamen={}
      this.titulo   = 'Crear Examen'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idExamen){
      this.modalWindow = true
      if(idExamen != null){    
           api.get('/vwexamens/'+idExamen).then(resp=>{
          this.datoExamen = resp.data;
           });
      }
      this.titulo   = 'Editar Examen'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarExamen(){
      this.$router.push('/Examen')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.elemexams.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwelemexams/nombre/'+this.nombreBusqueda).then(response=>{
          this.elemexams=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.elemexams.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwelemexams').then(response=>{
      this.elemexams=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.elemexams.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idTipoExamen'
        ,'nombre'
      ];
      const requiredFieldsText = [
        'idTipoExamen'
        ,'nombre'
      ];
      return validarForm(this.datoExamen, requiredFields, requiredFieldsText);
    },
    async guardarElemExam(){
      if(this.validarForm() === 1){
        try {
          this.datoElemExam.idExamen = this.datoExamen.idExamen;
          await api.post('/elemexams', this.datoElemExam)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ElemExam creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditElemExam(){
      if(this.validarForm() === 1){
        try {
          await api.post('/elemexams', this.datoElemExam)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ElemExam creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoElemExam={}
      this.titulo   = 'Crear Examen'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idElemExam){
      this.modalWindow = true
      if(idElemExam != null){    
           api.get('/vwelemexams/'+idElemExam).then(resp=>{
          this.datoElemExam = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Examen'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idElemExam){
      this.modalWindow = true
      if(idElemExam != null){
        this.$router.push('/elemexammd/'+idElemExam)
      }
    },
    async deleteElemExam (idElemExam) {
      try{
        await api.delete('/elemexams/'+idElemExam)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchTipoExamens() {
      fetch('http://localhost:8080/api/v1/tipoexamens')
        .then(response => response.json())
        .then(data => {
          this.tipoExamens = data;
        })
        .catch(error => {
          console.error('Error fetching tipoExamens:', error);
        });
    },
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/elementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
/*     fetchExamens() {
      fetch('http://localhost:8080/api/v1/examens')
        .then(response => response.json())
        .then(data => {
          this.examens = data;
        })
        .catch(error => {
          console.error('Error fetching examens:', error);
        });
    }, */
  },
}
</script>
